
import {
  GoodItem,
  CouponState,
  ExchangeState,
} from '@tencent/wphk-act-base-types';
import { CouponButtonType } from '@tencent/wphk-act-base-ui';
import { RawSkin } from '../api';

/** 扫码券礼包的券信息 */
export type ItemInfo = GoodItem & {
  /** 券Id */
  couponId: string;
  /** 券状态 */
  couponState: CouponState;
  /** 券兑换状态 */
  exchangeState?: ExchangeState;
  /** 去使用需要userCouponid*/
  userCouponid: string;
  // 领券参数
  getCouponParams: {
    /** 资格加密串 印花兑换活动需要 */
    qualId?: string;
    /** 活动加密串 */
    enActid: string;
    /** 奖品加密串 */
    prizeId: string;
  },
  /** 库存 */
  availablePercent: string;

  /** 是否展示coupon-small券上的button(包括领取/去使用) */
  isShowButton: boolean,
  /** 是否展示coupon-small券上的button(去使用) */
  isShowUseBtn: boolean,
  /** compon-small券，展示在btn位置的文案(今日已领完/本月已领完) */
  tipsText?: string;
  /** buttonType，决定券样式 */
  buttonType?: CouponButtonType,
};


/** 扫码券礼包-券类型，注意：要跟货源配置上的下拉选项值一致 */
export enum FixedCouponType {
  /** 普通券 */
  common = 'common',
  /** 商户专属券 */
  merchant = 'merchant',
  /** 特邀用户券 */
  invitedUser = 'invitedUser',
  /** 彩蛋券 */
  easterEgg = 'easterEgg',
}

/** 格式化后配置-券列表配置 */
export type ConfigCouponInfo = {
  /** 活动Id加密串 */
  actIdEn: string;
  /** 券类型 */
  type: FixedCouponType,
  /** 可领券时间列表([[s1, e1], [s2, e2]]) */
  ableTimeList: string[][];
};

/** 格式化后配置-单个campaignId的配置 */
export type ConfigScanGift = {
  /** 计划Id */
  campaignId: string;
  /** 固定券礼包 */
  fixedCouponInfo: ConfigCouponInfo[];
  /** tnc链接 */
  tncUrl: string;
  /** 商户Id */
  spIdList: string[];
  /** 组件皮肤 */
  skin: RawSkin;
  /** 模块自定义标题 */
  title: string;
  /** 弹窗组件图片 */
  promptDialogPic?: string;
};

/** 根据campaignId和spId筛选后&&当前时间生效的单个配置 */
export type ValidConfigItem = {
  /** 计划Id */
  campaignId: string;
  /** 固定券礼包 */
  fixedCouponInfo: ConfigCouponInfo[];
  /** tnc链接 */
  tncUrl: string;
  /** 商户Id - 这里只需要当前spId即可 */
  spId: string;
  /** 组件皮肤 */
  skin: RawSkin;
  /** 模块自定义标题 */
  title: string;
  /** 弹窗组件图片 */
  promptDialogPic?: string;
};
